import React from 'react';
import { motion } from 'framer-motion';
import { MapPin, Phone, Mail } from 'lucide-react';
export function Contact() {
  return <section id="contact" className="py-24 bg-background" data-id="element-42">
      <div className="max-w-7xl mx-auto px-6" data-id="element-43">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-start" data-id="element-44">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} data-id="element-45">
            <h2 className="text-3xl md:text-4xl font-semibold mb-6" data-id="element-46">
              Потрібна консультація?
            </h2>
            <p className="text-secondary mb-12 text-lg" data-id="element-47">
              Залиште свої контакти, і ми зв'яжемося з вами найближчим часом,
              щоб обговорити вашу ситуацію та запропонувати рішення.
            </p>

            <div className="space-y-6 mb-12" data-id="element-48">
              <div className="flex items-center gap-4 text-secondary" data-id="element-49">
                <div className="w-10 h-10 rounded-full bg-surface flex items-center justify-center text-primary" data-id="element-50">
                  <MapPin size={18} data-id="element-51" />
                </div>
                <span data-id="element-52">вул. Хрещатик, 15, Київ, Україна</span>
              </div>
              <div className="flex items-center gap-4 text-secondary" data-id="element-53">
                <div className="w-10 h-10 rounded-full bg-surface flex items-center justify-center text-primary" data-id="element-54">
                  <Phone size={18} data-id="element-55" />
                </div>
                <a href="tel:+380934593727" className="hover:text-primary transition-colors" data-id="element-56">
                  0 (93) 459 37 27
                </a>
              </div>
              <div className="flex items-center gap-4 text-secondary" data-id="element-57">
                <div className="w-10 h-10 rounded-full bg-surface flex items-center justify-center text-primary" data-id="element-58">
                  <Mail size={18} data-id="element-59" />
                </div>
                <a href="mailto:info@propyska.kyiv.ua" className="hover:text-primary transition-colors" data-id="element-60">
                  info@propyska.kyiv.ua
                </a>
              </div>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-surface p-8 rounded-3xl border border-border" data-id="element-61">
            <h3 className="text-xl font-medium mb-6" data-id="element-62">Опишіть вашу ситуацію</h3>
            <form className="flex flex-col gap-4 w-full" onSubmit={e => e.preventDefault()} data-id="element-63">
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-64">
                <input type="text" placeholder="Ім'я" className="w-full bg-background border border-border rounded-2xl px-5 py-4 outline-none focus:border-primary transition-colors text-primary placeholder-secondary" required data-id="element-65" />
                <input type="tel" placeholder="Телефон" className="w-full bg-background border border-border rounded-2xl px-5 py-4 outline-none focus:border-primary transition-colors text-primary placeholder-secondary" required data-id="element-66" />
              </div>
              <input type="email" placeholder="Email" className="w-full bg-background border border-border rounded-2xl px-5 py-4 outline-none focus:border-primary transition-colors text-primary placeholder-secondary" required data-id="element-67" />
              <textarea placeholder="Опишіть вашу ситуацію..." className="w-full bg-background border border-border rounded-2xl px-5 py-4 outline-none focus:border-primary transition-colors text-primary placeholder-secondary resize-none min-h-[120px]" required data-id="element-68" />
              <button type="submit" className="bg-primary text-background py-4 rounded-2xl font-medium hover:opacity-90 transition-opacity mt-2 w-full" data-id="element-69">
                Отримати консультацію
              </button>
            </form>
          </motion.div>
        </div>
      </div>
    </section>;
}